import axios from 'axios';
import { API_URL } from '../config';

// Axios instance for public /u/:token/* endpoints. Upload session bearer is
// attached per call from the page state (not from localStorage), since
// sessions are link scoped, not user scoped.
const pub = axios.create({ baseURL: API_URL });

export const publicApi = {
  getLink: (token) => pub.get(`/u/${token}`).then((r) => r.data),

  verifyStart: (token, body) =>
    pub.post(`/u/${token}/verify/start`, body).then((r) => r.data),

  verifyConfirm: (token, body) =>
    pub.post(`/u/${token}/verify/confirm`, body).then((r) => r.data),

  upload: (token, sessionToken, file, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    return pub
      .post(`/u/${token}/uploads`, form, {
        headers: { Authorization: `Bearer ${sessionToken}` },
        onUploadProgress: onProgress,
      })
      .then((r) => r.data);
  },

  done: (token, sessionToken) =>
    pub
      .post(`/u/${token}/done`, null, {
        headers: { Authorization: `Bearer ${sessionToken}` },
      })
      .then((r) => r.data),

  // sessionToken is the upload-session JWT issued by verify/confirm.
  optIn: (sessionToken, body) =>
    pub
      .post(`/client-auth/opt-in`, body, {
        headers: { Authorization: `Bearer ${sessionToken}` },
      })
      .then((r) => r.data),

  listChat: (token, sessionToken) =>
    pub
      .get(`/u/${token}/chat`, {
        headers: { Authorization: `Bearer ${sessionToken}` },
      })
      .then((r) => r.data),

  postChat: (token, sessionToken, body) =>
    pub
      .post(`/u/${token}/chat`, { body }, {
        headers: { Authorization: `Bearer ${sessionToken}` },
      })
      .then((r) => r.data),
};

export const clientAuthApi = {
  login: (email, password) =>
    pub.post('/client-auth/login', { email, password }).then((r) => r.data),
};
